import React, { Component } from 'react';

import SignIn from './SignIn';
import SignUp from './SignUp';

import DisclaimerIcon from '../Common/Profile/SvgIcon/DisclaimerIcon';
import NeedHelpIcon from '../Common/Profile/SvgIcon/NeedHelpIcon';

import ModalFooter from '../Common/Profile/ModalFooter';
import ModalDisclaimer from '../Common/Profile/ModalDisclaimer';
import ModalHelp from '../Common/Profile/ModalHelp';
import InclaimationIcon from '../Common/Profile/SvgIcon/InclaimationIcon';
import QuestionIcon from '../Common/Profile/SvgIcon/QuestionIcon';
import '../Home/Base/styles.css';
import { hot } from 'react-hot-loader';
import ForgotPasswordForm from './ForgotPassword/ForgotPasswordForm';
import ResetPasswordForm from './ForgotPassword/ResetPasswordForm';

import { Auth } from 'aws-amplify';

import UserService from '../../Service/UserService';
import AccountService from '../../Service/AccountService';
import { withTranslation } from 'react-i18next';

const APPLICATION_EXCEPTION = window.ApplicationException;
const APP_STRING = window.AppStrings;
const SCREEN = {
	SIGN_IN: 'SIGN_IN',
	SIGN_UP: 'SIGN_UP',
	FORGOT_PASSWORD: 'FORGOT_PASSWORD',
	ResetPasswordForm: 'ResetPasswordForm'
};

class index extends Component {
	// NOSONAR
	constructor(props) {
		super(props);
		this.state = {
			_openedScreen: SCREEN.SIGN_IN,
			_typeModal: '',
			_isModalOpen: false,
			_authError: '',
			_isForgotPassScrnOpen: true,
			_isLoading: false,
			_userPhone: '',
			_otpMode: APP_STRING.PHONE_NUMBER,

			_alert: {
				_show: false,
				_message: '',
				_severity: ''
			}
		};
	}

	resetAuthError = () => {
		this.setState({
			_authError: ''
		});
	};

	sendPasswordChangedConfirmationNotification = async phone => {
		await AccountService.sendChangedPasswordConfirmationNotify({ phone });
	};

	resetPassword = async passwordResetDetail => {
		this.setState({
			_isLoading: true
		});

		// Use URLSearchParams to parse query parameters
		const queryParams = new URLSearchParams(window.location.search);

		// Get the 'phone' query parameter
		const phone = `+${queryParams.get('phone')?.trim()}`;

		try {
			await Auth.forgotPasswordSubmit(
				this.state._userPhone || phone,
				passwordResetDetail.otp,
				passwordResetDetail.password
			);
			await this.showAlert(true, 'success', this.props.t('profile.password_successfully_sent'));
			this.setState({
				_isLoading: false
			});
			await this.sendPasswordChangedConfirmationNotification(this.state._userPhone || phone);
			setTimeout(() => {
				if (this.props.currentUser) {
					this.props.openScreen('HOME');
				} else {
					this.redirectToLoginScreen();
				}
			}, 2000);
		} catch (error) {
			this.setState({
				_isLoading: false
			});
			if (error.code === APPLICATION_EXCEPTION.CODE_MIS_MATCH_EXCEPTION) {
				this.setState({
					_authError: this.props.t('error_message.invalid_code')
				});
			} else {
				this.setState({
					_authError: error.message
				});
			}
		}
	};

	verifyPhoneIfExist = async phone => {
		this.setState({
			_isLoading: true
		});
		try {
			const res = await UserService.getUserByPhone(phone);
			if (res) {
				this.setState({
					_isLoading: false
				});
				return res;
			}
		} catch (err) {
			this.setState({
				_authError: err,
				_isLoading: false
			});
		}
	};

	forgotPassword = async phone => {
		this.setState({
			_userPhone: phone,
			_isLoading: true
		});

		try {
			const resp = await Auth.forgotPassword(phone);
			this.redirectToResetPassword(resp.CodeDeliveryDetails.AttributeName);
		} catch (error) {
			this.setState({
				_isLoading: false
			});
			if (
				error.code === APPLICATION_EXCEPTION.USER_NOT_FOUND_EXCEPTION ||
				error.code === APPLICATION_EXCEPTION.INVALID_PARAMETER_EXCEPTION
			) {
				this.setState({
					_authError: 'forgot_password.invalid_parameter_exception_message'
				});
			} else {
				this.setState({
					_authError: error.message
				});
			}
		}
	};

	redirectToResetPassword = mode => {
		this.setState({
			_isLoading: false,
			_isForgotPassScrnOpen: false,
			_otpMode: mode === APP_STRING.PHONE_NUMBER ? APP_STRING.MOBILE_NUMBER : mode
		});
	};

	redirectToLoginScreen = () => {
		this.openSignInForm();
	};

	showAlert = async (show, severity, message) => {
		const alert = {
			_show: show,
			_message: message,
			_severity: severity
		};
		await this.setState({
			_alert: alert
		});
	};

	hideAlert = async () => {
		const alert = {
			_show: false,
			_message: '',
			_severity: ''
		};
		await this.setState({
			_alert: alert
		});
	};

	openSignUpForm = () => {
		this.setState({
			_openedScreen: SCREEN.SIGN_UP
		});
	};

	openSignInForm = () => {
		this.setState({
			_openedScreen: SCREEN.SIGN_IN
		});
	};

	openForgotPasswordScreen = () => {
		this.setState({
			_openedScreen: SCREEN.FORGOT_PASSWORD
		});
	};

	openResetPasswordScreen = () => {
		this.setState({
			_openedScreen: SCREEN.ResetPasswordForm
		});
	};
	componentDidMount() {
		if (this.props.openAuth === SCREEN.SIGN_IN) {
			this.openSignInForm();
		} else if (this.props.openAuth === SCREEN.SIGN_UP) {
			this.openSignUpForm();
		} else if (this.props.openAuth === SCREEN.ResetPasswordForm) {
			this.openResetPasswordScreen();
		}
	}

	setTypeModal = e => {
		this.setState({
			_typeModal: e
		});
	};

	setIsModalOpen = () => {
		this.setState({
			_isModalOpen: !this.state._isModalOpen
		});
	};

	render() {
		const Footer = () => {
			return (
				<>
					{/* <div className="profile-footer-icons-container"> */}
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							marginTop: '20px',
							width: '100%',
							paddingLeft: '40px',
							paddingRight: '40px'
						}}>
						<DisclaimerIcon
							onClick={() => {
								this.setTypeModal('disclaimer');
								this.setIsModalOpen();
							}}
						/>
						<NeedHelpIcon
							onClick={() => {
								this.setTypeModal('needhelp');
								this.setIsModalOpen();
							}}
						/>
					</div>

					<ModalFooter
						open={this.state._isModalOpen}
						typeModal={this.state._typeModal}
						content={
							this.state._typeModal === 'disclaimer' ? (
								<ModalDisclaimer icon={<InclaimationIcon />} />
							) : (
								<ModalHelp
									email="contact@lendami.com.ph"
									number="+639176544580"
									icon={<QuestionIcon />}
								/>
							)
						}
						setIsModalOpen={this.setIsModalOpen}
					/>
				</>
			);
		};
		switch (this.state._openedScreen) {
			case SCREEN.SIGN_UP:
				return (
					<>
						<SignUp
							onCloseWhenLoanExists={this.props.onCloseWhenLoanExists}
							openScreen={this.props.openScreen}
							openSignInForm={this.openSignInForm}
							props={this.props.props}
							setCurrentUser={this.props.setCurrentUser}
							setInitialScreen={this.props.setInitialScreen}
							supportedStates={this.props.supportedStates}
							user={this.props.user}
							footer={<Footer />}
						/>
					</>
				);
			case SCREEN.SIGN_IN:
				return (
					<SignIn
						onCloseWhenLoanExists={this.props.onCloseWhenLoanExists}
						openForgotPasswordScreen={this.openForgotPasswordScreen}
						openScreen={this.props.openScreen}
						openSignUpForm={this.openSignUpForm}
						props={this.props.props}
						setCurrentUser={this.props.setCurrentUser}
						setInitialScreen={this.props.setInitialScreen}
						user={this.props.user}
						footer={<Footer />}
					/>
				);
			case SCREEN.FORGOT_PASSWORD:
				if (this.state._isForgotPassScrnOpen) {
					return (
						<ForgotPasswordForm
							verifyPhoneIfExist={this.verifyPhoneIfExist}
							alert={this.state._alert}
							authError={this.state._authError}
							hideAlert={this.hideAlert}
							isLoading={this.state._isLoading}
							onForgot={this.forgotPassword}
							openSignInForm={this.state.openSignInForm}
							resetAuthError={this.resetAuthError}
						/>
					);
				} else {
					return (
						<ResetPasswordForm
							alert={this.state._alert}
							authError={this.state._authError}
							hideAlert={this.hideAlert}
							isLoading={this.state._isLoading}
							mode={this.state._otpMode}
							onReset={this.resetPassword}
							resetAuthError={this.resetAuthError}
						/>
					);
				}
			case SCREEN.ResetPasswordForm:
				return (
					<ResetPasswordForm
						alert={this.state._alert}
						authError={this.state._authError}
						hideAlert={this.hideAlert}
						isLoading={this.state._isLoading}
						mode={this.state._otpMode}
						onReset={this.resetPassword}
						resetAuthError={this.resetAuthError}
					/>
				);

			default:
				return null;
		}
	}
}

export default withTranslation()(hot(module)(index));
